import { useEffect, useState } from "react";
import { SortOptions } from "../../pages/Visualization";
import { Parameter } from "../../types/Parameter";

type SortProps = {
  parameters: Parameter[];
  onSort: (sortOptions: SortOptions) => void;
};

const Sort = (props: SortProps) => {
  const [sortType, setSortType] = useState<"parameters" | "date">("parameters");
  const [selectedParameter, setSelectedParameter] = useState("");
  const [order, setOrder] = useState<"increasing" | "decreasing">("increasing");

  useEffect(() => {
    // Update the selectedParameter whenever the parameters list changes
    if (props.parameters.length > 0) {
      setSelectedParameter(props.parameters[0].key);
    }
  }, [props.parameters]); // Depend on props.parameters

  const handleSortTypeChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    event.preventDefault();
    setSortType(event.target.value as "parameters" | "date");
  };

  const handleParameterChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    event.preventDefault();
    setSelectedParameter(event.target.value);
  };

  const handleOrderChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.preventDefault();
    setOrder(event.target.value as "increasing" | "decreasing");
  };

  const handleApply = () => {
    props.onSort({
      type: sortType,
      parameterKey: selectedParameter,
      order: order,
    });
  };

  return (
    <div className="parameter-box">
      <h4 className="title">Sort</h4>
      <div>
        <label htmlFor="sort-type">Sort by: </label>
        <select id="sort-type" value={sortType} onChange={handleSortTypeChange}>
          <option value="date">Date</option>
          <option value="parameters">Parameters</option>
        </select>
      </div>

      {sortType === "parameters" && (
        <div>
          <label htmlFor="parameter">Parameter: </label>
          <select
            id="parameter"
            value={selectedParameter}
            onChange={handleParameterChange}
          >
            {props.parameters.map((paramater: Parameter) => (
              <option key={paramater.id} value={paramater.key}>
                {paramater.key}
              </option>
            ))}
          </select>
        </div>
      )}

      <div>
        <label htmlFor="order">Order: </label>
        <select id="order" value={order} onChange={handleOrderChange}>
          <option value="increasing">Increasing</option>
          <option value="decreasing">Decreasing</option>
        </select>
      </div>

      <button className="btn apply-sort" onClick={handleApply}>
        Apply
      </button>
    </div>
  );
};

export default Sort;
